var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObject},_vm._l((_vm.row),function(achievement,i){return _c('SecretAchievement',{key:i,staticClass:"l-achievement-grid__cell",attrs:{"achievement":achievement}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }